<template>
    <Card style="height: 100%;" id="card">
        <div class="count-number" type="flex" align="middle">
            <div v-if="!showLoadingGif" class="count-to"  >{{value}}</div>
            <div v-if="showLoadingGif">
                <img style="width: 4em;" src="../../../../public/images/1.gif" alt="">
            </div>
            <h5 class="title" :class="'bg-'+ color" @click="$emit('onRoute')">
                {{title}}
            </h5>
        </div>
    </Card>
</template>

<script>
    // import CountTo from "../../iview-admin-components/count-to/CountTo";
    export default {
        name: "count-number",
        // components: {CountTo},
        props: {
            value: {
                type: String,
                default: "0"
            },
            showLoadingGif:Boolean,
            title: String,
            color: {
                type: String,
                default: 'white'
            },
            icon: String
        },
        computed:{
            outerHeight(){
                return window.outerHeight;
            }
        },
    }
</script>

<style lang="less" scoped>
    @import "../../../plugins/iconfont/iconfont.css";
    .bg{
        &-red {background: #1dd1a1;}
        &-blue {background: #3399ff;}
        &-yellow {background: #99ff66;}
        &-green {background: #00cc99;}
        &-orange {background: #ff6600;}
        &-pink {background: #cc6666;}
        &-fault {background: #5b9bd5;}
        &-fault_collection {background: #92d050;}
        &-warn_collection {background: #ffc000;}
    }
    .count-number{
        height: 100%;
        display: grid;
        align-items: center;
    }
    .count-to{
        font-size: 18px;
        height: 100%;
        color: #808080;
        font-weight: 500;
        color: gray;
    }
    .title {
        color: white;
        padding: 1px 0;
        position: relative;
        cursor: pointer;
        font-size: 1em;
        &>.icon{
            position: absolute;
            display: inline-block;
            right: 10px;
            font-weight: bolder;
        }
    }
</style>